<template>
  <!-- align-top + min-height เท่าแถว input แรก → ชื่อ/หน่วย/ปุ่มลบเรียงแนวเดียวกับ input บนเสมอ
       (ช่องปริมาณอาจสูง 2 ชั้นเมื่อมีช่อง "เดี่ยว" ของกลุ่ม split_portion) -->
  <td class="py-2 align-top">
    <div class="d-flex align-items-center gap-2" style="min-height: 31px;">
      <i class="fa-solid fa-box-open text-secondary" style="font-size: 11px; opacity: 0.6;" />
      <span>{{ recipe.name }}</span>
    </div>
  </td>
  <td class="py-2 align-top">
    <div class="input-group input-group-sm">
      <input
        type="number"
        v-model.trim="v$.recipe.quantity_system.$model"
        inputmode="decimal"
        class="form-control shadow-none text-end"
        style="font-size: 12px;"
        placeholder="0.00"
      >
    </div>
    <!-- ปริมาณโหมดเดี่ยว (เฉพาะกลุ่ม split_portion) — เว้นว่าง = ใช้ปริมาณปกติ -->
    <div v-if="showSolo" class="input-group input-group-sm mt-1">
      <span class="input-group-text" style="font-size: 10px; background: #fffcf5; color: #b34700;">{{ $t('Solo') }}</span>
      <input
        type="number"
        v-model.trim="recipe.quantity_system_solo"
        inputmode="decimal"
        class="form-control shadow-none text-end"
        style="font-size: 12px; background: #fffcf5;"
        :placeholder="'(' + $t('blank = normal') + ')'"
      >
    </div>
    <div v-for="error of v$.recipe.quantity_system.$errors"
      class="d-block invalid-feedback"
      :key="error.$uid"
    >
      {{ error.$message }}
    </div>
  </td>
  <td class="py-2 align-top">
    <div class="input-group input-group-sm">
      <input
        type="number"
        v-model.trim="v$.recipe.quantity_display.$model"
        inputmode="decimal"
        class="form-control shadow-none text-end"
        style="font-size: 12px;"
        placeholder="0.00"
      >
    </div>
    <div v-if="showSolo" class="input-group input-group-sm mt-1">
      <span class="input-group-text" style="font-size: 10px; background: #fffcf5; color: #b34700;">{{ $t('Solo') }}</span>
      <input
        type="number"
        v-model.trim="recipe.quantity_display_solo"
        inputmode="decimal"
        class="form-control shadow-none text-end"
        style="font-size: 12px; background: #fffcf5;"
        :placeholder="'(' + $t('blank = normal') + ')'"
      >
    </div>
    <div v-for="error of v$.recipe.quantity_display.$errors"
      class="d-block invalid-feedback"
      :key="error.$uid"
    >
      {{ error.$message }}
    </div>
  </td>
  <td class="py-2 align-top">
    <div class="d-flex align-items-center" style="min-height: 31px;">
      <span
        class="badge"
        style="background: #e8f4fd; color: #1a6fa8; border: 1px solid #b8daef; font-size: 11px; font-weight: 500;"
      >
        {{ $t(recipe.unit_name) }}
      </span>
    </div>
  </td>
  <td class="text-end py-2 align-top">
    <div class="d-flex align-items-center justify-content-end" style="min-height: 31px;">
      <button
        type="button"
        class="btn btn-sm btn-outline-danger d-inline-flex align-items-center justify-content-center"
        style="font-size: 10px; width: 24px; height: 24px; padding: 0;"
        @click="$parent.deleteItem(index)"
      >
        <i class="fa-solid fa-trash" />
      </button>
    </div>
  </td>
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-item";
import moment from "moment";
import numeral from 'numeral';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.recipe)
  },
  props: {
    recipe: {
      type: Object,
      default: {}
    },
    index: {
      type: Number,
      required: true
    },
    showSolo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let vm = this;
    return {
    }
  },
  components: {
  },
  methods: {
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatDateTime(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss');
    },
  },
  async mounted() {},
  computed: {
  },
  watch: {
  }
}
</script>
